<template>
  <div>
    <ol id="tallyMark">
      <li v-for="index in JSON.parse(value)" :key="index"></li>
      &nbsp;
    </ol>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true
    },
    shouldUseTally: Boolean
  }
};
</script>

<style scoped lang="scss">
ol {
  margin: 0;
  padding-left: 15px;
  li {
    display: inline-block;
    height: 15px;
    border: 1px solid #000;
    margin-right: 8px;
    &:nth-child(5n) {
      transform: rotate(250deg);
      -webkit-transform: rotate(250deg);
      -moz-transform: rotate(250deg);
      -o-transform: rotate(250deg);
      height: 40px;
      position: relative;
      left: -25px;
      top: 12px;
      margin-right: 8px;
      margin-top: -10px;
    }
  }
}
</style>
